<div class="p-grid">
    <div class="p-col-12 p-field">
        <label for="zone">Zona</label>
        <p-dropdown name="zone" optionValue="id" [options]="zones" [(ngModel)]="userZone.zone_id" optionLabel="name" appendTo="body" placeholder="Selecciona una zona"></p-dropdown>
    </div>
    <div class="p-col-12">
        <button pButton class="p-ml-2" style="float: right;" (click)="save()" icon="pi pi-check"
            label="Guardar"></button>
        <button pButton class="p-button-secondary p-button-text" style="float: right;" (click)="cancel()" icon="pi pi-times"
            label="Cancelar"></button>
    </div>
</div>